var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.callWaiterEnabled)?_c('Button',{staticClass:"button is-primary is-large",attrs:{"data-cy":"select-screen-call-waiter","no-shadow":""},on:{"click":_vm.callWaiter}},[_vm._v(" "+_vm._s(_vm.$t('screens.selectScreen.callWaiterCta'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }